import {DateTime} from 'luxon';
import {eventSlots,parseSetupKey,setupKey} from '../../utils/eventSetup';
import {publicContentLink} from '../../utils/sharedContentLinks';

export const WORKSPACE_TABS=['prep','vod','summary','stats'];
export function workspaceTab(value){return WORKSPACE_TABS.includes(value)?value:'prep';}
export function workspaceSlot(event,id){const slots=eventSlots(event);return slots.find(slot=>slot.id===id)||slots[0];}
export function workspaceSchedule(event,zone) {
  const start=DateTime.fromISO(event?.startUTC||'',{zone}),end=DateTime.fromISO(event?.endUTC||'',{zone});
  if(!start.isValid||!end.isValid)return 'Schedule unavailable';
  return start.toFormat('ccc, d LLL yyyy · HH:mm')+' – '+end.toFormat(end.hasSame(start,'day')?'HH:mm':'ccc, d LLL yyyy · HH:mm');
}
export function workspaceShareUrl(event,tab,slotId,zone,videoId){
  const params=new URLSearchParams({calendarTeam:event.__teamId,eventWorkspace:setupKey(event,slotId),eventTab:workspaceTab(tab)});
  if(event.startUTC)params.set('calendarDate',DateTime.fromISO(event.startUTC,{zone}).toISODate());
  if(zone)params.set('calendarTimeZone',zone);
  // A private file path is meaningful only on this computer, never in a share URL.
  if(videoId&&!String(videoId).startsWith('local:'))params.set('eventVideo',videoId);
  return publicContentLink('/home?'+params);
}
export function workspaceEventFromKey(key,teamId){
  const parsed=parseSetupKey(key);
  const valid=typeof teamId==='string'&&teamId.length>0&&teamId.length<=128&&!teamId.includes('/')&&!teamId.includes('\\')&&!Array.from(teamId).some(char=>char.charCodeAt(0)<32)&&teamId!=='.'&&teamId!=='..';
  return parsed?.scope==='team'&&valid?{event:{eventId:parsed.eventId,instanceDate:parsed.instanceDate,__teamId:teamId},slotId:parsed.slotId}:null;
}
